import { useState } from 'react';
import { Settings, Users, BarChart3, Shield, Zap, Building2, Smartphone, Wrench, DollarSign, Grid3X3, MessageSquare, AlertTriangle, Cpu, Wifi, Link, ChevronDown, ChevronUp, Check, Plus, Bot, Headphones, FileText, Mail, Phone, GraduationCap } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from '@shared/ui/card';
import { Button } from '@shared/ui/button';
import { Badge } from '@shared/ui/badge';
import { Collapsible, CollapsibleContent, CollapsibleTrigger } from '@shared/ui/collapsible';
import { useAddOnsList, usePostAddons } from '../hooks';
import { useTenantId } from '@shared/selectors/globalSelectors';
interface AddOnFeature {
  name: string;
  description: string;
}
interface AddOnPackage {
  id: string;
  name: string;
  priceRange: string;
  icon: React.ComponentType<any>;
  features: AddOnFeature[];
}
interface AddOnCategory {
  id: string;
  title: string;
  emoji: string;
  packages: AddOnPackage[];
}
const AddOnPackages = ({refetchSupportRequests}) => {

  const {data: addOnsList} = useAddOnsList();
  // console.log('debug add ons data', addOnsList)
  const {mutate: addAddOn} = usePostAddons();
  const tenantId = useTenantId();
  const [openCategories, setOpenCategories] = useState<Record<string, boolean>>({});
  const toggleCategory = (categoryId: string) => {
    setOpenCategories(prev => ({
      ...prev,
      [categoryId]: !prev[categoryId]
    }));
  };



// Icon mapping for packages
  const getIconForPackage = (packageName: string) => {
    const iconMap: Record<string, React.ComponentType<any>> = {
      'Advanced Customer Portal': Users,
      'Mobile Self-Service App': Smartphone,
      'Automated Customer Care': MessageSquare,
      'Custom Reports & Analytics': BarChart3,
      'Data Migration Services': FileText,
      'Strategic Consulting': Users,
      'On-Site Training Programs': GraduationCap,
      'Premium SLA Support': Headphones,
      'Remote Training & Certification': Wifi,
      'Communication Services': Mail,
      'API Usage & Integrations': Link,
      'Storage & Processing': Settings,
      'AI Utility Agents': Bot,
      'Smart Analytics Engine': Cpu,
      'AI Operations Optimization': Zap
    };
    return iconMap[packageName] || Settings;
  };
   const addOnCategories = addOnsList?.map(category => ({
    id: category?.categoryName,
    title: category?.categoryName,
    packages: category?.packages?.map(pkg => ({
      id: pkg?.id?.toString(),
      name: pkg?.name,
      priceRange: pkg?.priceRange,
      icon: getIconForPackage(pkg.name),
      features: pkg?.features?.map(feature => ({
        name: feature?.title,
        description: feature?.description
      }))
    }))
  })) || [];
  const handleContactSales = (categoryId: string) => {
    addAddOn({
      tenantId,
      addon_id: categoryId,
    }, {
      onSuccess: () => {
        refetchSupportRequests();
      }
    })
  }
  return <div className="space-y-6">
      <div className="text-center mb-8">
        <h2 className="text-3xl font-bold text-gray-800 mb-2">Add-On Packages</h2>
        <p className="text-gray-600">Extend your Smart360 platform with powerful add-on capabilities</p>
      </div>

      {addOnCategories?.map(category => <Card key={category.id} className="border border-smart360-border">
          <Collapsible open={openCategories[category.id]} onOpenChange={() => toggleCategory(category.id)}>
            <CollapsibleTrigger asChild>
              <CardHeader className="cursor-pointer hover:bg-gray-50 transition-colors">
                <div className="flex items-center justify-between pb-4">
                  <CardTitle className="text-xl text-center m-0">
                    
                    {category.title} Add-Ons
                  </CardTitle>
                  <div className="flex items-center gap-2">
                    <Badge variant="secondary" className="text-sm">
                      {category.packages.length} packages
                    </Badge>
                    {openCategories[category.id] ? <ChevronUp className="h-5 w-5" /> : <ChevronDown className="h-5 w-5" />}
                  </div>
                </div>
              </CardHeader>
            </CollapsibleTrigger>

            <CollapsibleContent>
              <CardContent className="pt-0">
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                  {category.packages?.map(pkg => <Card key={pkg.id} className="border border-gray-200 hover:shadow-md transition-shadow">
                      <CardHeader className="pb-4">
                        <div className="flex items-start justify-between">
                          <div className="flex items-center">
                            <div className="w-10 h-10 rounded-lg bg-smart360-primary/10 flex items-center justify-start">
                              <pkg.icon className="h-5 w-5 text-smart360-primary" />
                            </div>
                            <div>
                              <h4 className="font-semibold text-gray-800">{pkg.name}</h4>
                              <p className="text-sm text-smart360-primary font-medium">{pkg.priceRange}</p>
                            </div>
                          </div>
                        </div>
                      </CardHeader>
                      
                      <CardContent className="pt-0">
                        <div className="space-y-3">
                          {pkg.features?.map((feature, idx) => <div key={idx} className="flex items-start gap-2">
                              <Check className="h-4 w-4 text-green-500 mt-0.5 flex-shrink-0" />
                              <div>
                                <div className="font-medium text-sm text-gray-700">{feature.name}</div>
                                <div className="text-xs text-gray-500">{feature.description}</div>
                              </div>
                            </div>)}
                        </div>
                        
                        <div className="mt-4 pt-4 border-t border-gray-100">
                          <Button
                          onClick={() => handleContactSales(pkg.id)}
                          variant="default" className="w-full border-smart360-primary hover:bg-smart360-primary">
                            <Plus className="h-4 w-4" />
                             Contact Sales
                          </Button>
                        </div>
                      </CardContent>
                    </Card>)}
                </div>
              </CardContent>
            </CollapsibleContent>
          </Collapsible>
        </Card>)}
    </div>;
};
export default AddOnPackages;